<!-- Main Container -->
<div class="min-h-screen bg-gray-100 text-gray-900">

  <!-- Navbar -->
  <nav class="navbar">
    <div class="navbar-left">
      <img src="../../assets/img/lo.png" alt="Logo" class="logo" />
    </div>
    <div class="navbar-right">
      <button class="back-btn" onclick="location.href='/'" aria-label="Go back home" style="color: #00d4ff;" >

        <span>Back to Home</span>
        <i class="bi bi-arrow-right-square "></i>
      </button>
    </div>
  </nav>


  <!-- Datatable Container -->
  <div class="datatable-container p-4 max-w-full bg-white rounded shadow-md mt-6 mx-auto">
    <h2 class="text-2xl font-semibold mb-4">Feedback Data</h2>

    <div class="controls">
      <div class="controls-left">
        <input type="text" placeholder="Search ..." [(ngModel)]="searchTerm" (input)="applyFilters()" />

        <select [(ngModel)]="filterCriteria.type" (change)="applyFilters()">
          <option value="">All Types</option>
          @for (type of uniqueTypes; track type) {
            <option [value]="type">{{ type }}</option>
          }
        </select>

        <select [(ngModel)]="itemsPerPage" (change)="onItemsPerPageChange()">
          @for (n of itemsPerPageOptions; track n) {
            <option [value]="n">{{ n }} per page</option>
          }
        </select>
      </div>

      <button (click)="exportToCSV()"
        class="export-csv-btn"
        title="Export feedback data to CSV">
        <i class="bi bi-download"></i>
        <span>Export to CSV</span>
      </button>
    </div>

    <table class="table-auto w-full border border-gray-300 text-sm">
      <thead>
        <tr class="bg-gray-100"><th class="border px-3 py-2 cursor-pointer" (click)="sortBy('userId')">
          S.No
          @if (sortColumn === 'userId') {
            <span>{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
          }
        </th><th class="border px-3 py-2 cursor-pointer" (click)="sortBy('userId')">
        Email
        @if (sortColumn === 'userId') {
          <span>{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
        }
      </th>
      <th class="border px-3 py-2 cursor-pointer" (click)="sortBy('type')">
        Type
        @if (sortColumn === 'type') {
          <span>{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
        }
      </th>
      <th class="border px-3 py-2 cursor-pointer" (click)="sortBy('description')">
        Description
        @if (sortColumn === 'description') {
          <span>{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
        }
      </th>
      <th class="border px-3 py-2 cursor-pointer" (click)="sortBy('datetime')">
        Datetime
        @if (sortColumn === 'datetime') {
          <span>{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
        }
      </th>
      <!-- <th class="border px-3 py-2 cursor-pointer" (click)="sortBy('id')">
      ID
      <span *ngIf="sortColumn === 'id'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
    </th> -->
    <th class="border px-3 py-2 text-center">Actions</th>
  </tr>
</thead>
<tbody>
  @for (item of paginatedData; track item; let i = $index) {
    <tr class="hover:bg-gray-50">
      <td class="border px-3 py-2">{{ i+1 }}</td>
      <td class="border px-3 py-2">{{ item.userId }}</td>
      <td class="border px-3 py-2">{{ item.type }}</td>
      <td class="border px-3 py-2">{{ item.description }}</td>
      <td class="border px-3 py-2">{{ item.datetime | date: 'medium' }}</td>
      <!-- <td class="border px-3 py-2 break-all">{{ item.id }}</td> -->
      <td class="border px-3 py-2 text-center">
        <button class="delete-btn" (click)="deleteFeedback(item.id)">
          <i class="bi bi-trash-fill"></i>
        </button>
      </td>
    </tr>
  }
  @if (paginatedData.length === 0) {
    <tr>
      <td class="text-center py-4" colspan="6">No feedback data available</td>
    </tr>
  }
</tbody>
</table>

<div class="pagination flex justify-center gap-2 mt-4">
  <button (click)="changePage(currentPage - 1)" [disabled]="currentPage === 1"
  class="px-3 py-1 border rounded disabled:opacity-50">Prev</button>

  @for (page of [].constructor(totalPages); track page; let i = $index) {
    <button (click)="changePage(i + 1)"
      [class.font-bold]="currentPage === i + 1" class="px-3 py-1 border rounded hover:bg-gray-200">
      {{ i + 1 }}
    </button>
  }

  <button (click)="changePage(currentPage + 1)" [disabled]="currentPage === totalPages"
  class="px-3 py-1 border rounded disabled:opacity-50">Next</button>
</div>
</div>
</div>
